import { HttpErrorResponse, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { AuthserviceService } from '../authservice.service';
import { HttpRequest, HttpHandlerFn, HttpEvent } from '@angular/common/http';
import { catchError, Observable, throwError } from 'rxjs';
import { Router } from '@angular/router';

export const authInterceptor: HttpInterceptorFn = (req: HttpRequest<any>, next: HttpHandlerFn): Observable<HttpEvent<any>> => {
  const authService = inject(AuthserviceService);
  const router = inject(Router);
  const token = authService.getToken();
  const clonedRequest = token
    ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
    : req;

    return next(clonedRequest).pipe(
      catchError((error: HttpErrorResponse) => {
        if (error.status === 401 || error.status === 403) {
          // Token expired or unauthorized
          localStorage.removeItem('token'); // clear token
          localStorage.removeItem('userData'); // clear token
          router.navigate(['/']); // redirect to login
        }
        return throwError(() => error);
      })
    );
};


 // Skip interception for login or public endpoints
//  if (req.url.includes('/login') || req.url.includes('/public')) {
//   return next(req); // just forward it
// }

// const token = authService.getToken();

// const clonedRequest = token
//   ? req.clone({ setHeaders: { Authorization: `Bearer ${token}` } })
//   : req;

// return next(clonedRequest).pipe(
//   catchError((error: HttpErrorResponse) => {
//     if (error.status === 401) {
//       authService.logout();
//       router.navigate(['/login']);
//     }
//     return throwError(() => error);
//   })
// );